module.exports = "https://coursera_assets.s3.amazonaws.com/images/4687539cbcbefca0d703e48577636851.png";